import { 
    Button,
    Card,
    CardBody,
    Col,
    Row,
    TabContent,
    TabPane
} from "reactstrap";
import "./CommunityDiscussion.css";
import GroupChatPage from "../chat/page/GroupChatPage";
import CustomerCoordinatorChat from "../Private/Pages/CustomerCoordinatorChat";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

interface Props {
    groupId: string;
    isJoined: boolean;
    coordinatorName: string;
    totalMembers: number;
}

const CommunityDiscussion = ({
    groupId,
    isJoined,
    coordinatorName,
    totalMembers,
}: Props) => {

    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("coordinator");

    if (!isJoined) {
        return (
            <>
                <p className="text-muted">
                    Join this community to interact with the coordinator and other learners.
                </p>

                {isAuthenticated ? (
                    <Button color="primary" size="lg">
                        Join Community
                    </Button>
                ) : (
                    <Button
                        color="primary"
                        onClick={() => navigate("/login")}
                    >
                        Login
                    </Button>
                )}
            </>
        );
    }

    return (
       <Card
  className="border-0 shadow"
  style={{
    borderRadius: "20px",
    overflow: "hidden",
    background: "#fff",
  }}
>
            <CardBody>

               <Row className="g-3 mb-3">
  <Col xs="12" md="6">
    <Button
      className="w-100"
      style={{
        padding: "14px",
        minHeight: "55px",
        borderRadius: "12px",
        background:
          activeTab === "coordinator"
            ? "linear-gradient(135deg,#198754,#20c997)"
            : "#fff",
        color: activeTab === "coordinator" ? "#fff" : "#212529",
        fontWeight: 600,
        border:
          activeTab === "coordinator"
            ? "none"
            : "1px solid #dee2e6",
        boxShadow:
          activeTab === "coordinator"
            ? "0 6px 18px rgba(25,135,84,.25)"
            : "none",
      }}
      onClick={() => setActiveTab("coordinator")}
    >
      💬 Chat With Coordinator
    </Button>
  </Col>

  <Col xs="12" md="6">
    <Button
      className="w-100"
      style={{
        padding: "14px",
        minHeight: "55px",
        borderRadius: "12px",
        background:
          activeTab === "group-members"
            ? "linear-gradient(135deg,#198754,#20c997)"
            : "#fff",
        color: activeTab === "group-members" ? "#fff" : "#212529",
        fontWeight: 600,
        border:
          activeTab === "group-members"
            ? "none"
            : "1px solid #dee2e6",
        boxShadow:
          activeTab === "group-members"
            ? "0 6px 18px rgba(25,135,84,.25)"
            : "none",
      }}
      onClick={() => setActiveTab("group-members")}
    >
      👥 Chat With Group Members
    </Button>
  </Col>
</Row>

                <TabContent activeTab={activeTab}>

                    <TabPane tabId="coordinator">

                        <Card
  className="border-0 shadow-sm"
  style={{
    borderRadius: "18px",
    overflow: "hidden",
    background: "#f8fffb",
  }}
>
  <CardBody style={{ padding: "20px" }}>

                                {/* <div className="mb-3">
                                    <strong>Coordinator:</strong>{" "}
                                    {coordinatorName || "Not Assigned"}
                                </div> */}

                               <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
    padding: "15px 20px",
    marginBottom: "20px",
    borderBottom: "1px solid #dee2e6",
  }}
>
  <h5
    style={{
      margin: 0,
      fontWeight: 700,
      color: "#198754",
    }}
  >
    💬 Coordinator
  </h5>

  <h6
    style={{
      margin: 0,
      color: "#6c757d",
      fontWeight: 600,
    }}
  >
    You
  </h6>

                                </div>

                                <CustomerCoordinatorChat
                                    groupId={groupId}
                                />

                            </CardBody>
                        </Card>

                    </TabPane>

                    <TabPane tabId="group-members">

                    <Card
  className="border-0 shadow-sm"
  style={{
    borderRadius: "18px",
    overflow: "hidden",
    background: "#f8fffb",
  }}
>
  <CardBody style={{ padding: "20px " }}>

                                <div className="chat-header d-flex justify-content-between align-items-center">

                                    <small>
                                        {totalMembers} Members
                                    </small>
                                </div>

                                <GroupChatPage
                                    groupId={groupId}
                                />

                            </CardBody>
                        </Card>

                    </TabPane>

                </TabContent>

            </CardBody>
        </Card>
    );
};

export default CommunityDiscussion;